/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Search_LengthInputs */

const fr_validation_search_length = /** @type {(inputs: Validation_Search_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitez la recherche à 200 caractères.`)
};

const en_validation_search_length = /** @type {(inputs: Validation_Search_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the search within 200 characters.`)
};

/**
* | output |
* | --- |
* | "Keep the search within 200 characters." |
*
* @param {Validation_Search_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_search_length = /** @type {((inputs?: Validation_Search_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Search_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_search_length(inputs)
	return fr_validation_search_length(inputs)
});